'use strict';

import {app} from '../../app';
import {ILocationService, ILogService, ITimeoutService} from "angular";
import {AbstractComponent} from "../AbstractComponent/AbstractComponent";
import {IAccountAutomaticBlocks, IAppModel, IBlock, ILastDelivery, IRootScope, ITemplateDeliveryTypes, ITemplateLayerClips} from "../../hpc";
import * as _ from "underscore";
import * as restangular from "restangular";
import {IResponse} from "restangular";
import {TrackerService} from "../../services/TrackerService";
import {DeliveryService} from "../../services/DeliveryService";
import {PrelistenService} from "../../services/PrelistenService";
import {PhoneNumberFormatterService} from "../../services/PhoneNumberFormatterService";

export enum playStatus {
    PLAY,
    LOAD,
    STOP
}

interface IQueuedBlockUpdate {
    clip: ITemplateLayerClips;
    type: string;
    templateLayerClipId: number;
    value: string;
}

export class EditAnnouncement extends AbstractComponent {

    public static $inject = ['$log', '$rootScope', '$scope', '$sessionStorage', 'Restangular', '$timeout', 'tracker', '$moment', 'properties','$location','deliveryService','prelistenService', 'phoneNumberFormatter'];

    constructor(
        private $log: ILogService,
        private $rs: IRootScope,
        private $s,
        public appModel: IAppModel,
        private Rest: restangular.IService,
        private $timeout: ITimeoutService,
        private tracker: TrackerService,
        private $moment,
        private properties,
        private $location: ILocationService,
        private deliveryService: DeliveryService,
        private prelistenService: PrelistenService,
        private phoneNumberFormatter: PhoneNumberFormatterService) {
        super();
    }

    public lastDelivery: ILastDelivery;
    public announcements;

    //scheduler bindings
    public begin: Date = new Date();
    public end: Date;
    public isActivateNow: boolean = true;
    public noEnd: boolean = true;
    public showEnd: boolean = false;


    public loading: boolean = true;
    public audioSupported;
    public textLayer;
    public deliveryTypes;
    public templateText: string;
    public currentList: any;
    public currentClip: any;
    public fileUrl: string;
    public noScheduler: boolean; //for autoAnnouncements
    public autoAnnouncementType: 'defaultAnnouncement'|'oooAnnouncement'; // oooAnnouncement/defaultAnnouncement
    public isEdit: boolean; //is this a new or existing autoAnnouncement
    public suggestionLists = {};
    public hasAutoDateBlock: boolean = false;


    $onInit(): void {
        this.$log.info('init Edit Announcement');

        this.noScheduler = this.$location.search().noScheduler;
        this.autoAnnouncementType = this.$location.search().type;
        this.isEdit = this.$location.search().isEdit;

        this.template = this.appModel.currentTemplate;
        !this.appModel.suggestionLists ? this.appModel.suggestionLists = {} : null;

        this.$s.$on('close', (data) => {
            this.$s.currentList = null;
            this.checkIsComplete();
        });

        this.$s.$on('refresh', (data) => {
            this.currentClip.isComplete = true;
            this.checkIsComplete();
        });

        this.$s.$watch('$ctrl.end', (newV:Date, oldV:Date) => {
            if ((newV instanceof Date && oldV instanceof Date && newV.getTime() === oldV.getTime()) || newV === oldV) {
                return;
            }
            console.log('end changed: ' + newV);
            this.appModel.currentAnnouncement.endDate = newV;
            this.createDisplaylist();
        });

        //prevent back button to leave route on open selectionList. Rather close the list
        this.$s.$on('$locationChangeStart', (event) => {
            if(this.currentList && this.currentList.length > 0){
                this.currentList = null;
                this.currentClip = null;
                event.preventDefault();
            }
        })

        this.audioSupported = () => {
            return this.prelistenService.audioSupported();
        };

        if(!this.noScheduler){
            //this.end = new Date(this.begin.getTime() + 24 * 60 * 60 * 1000);
            this.noEnd = true;
        }

        this.announcements = this.Rest.all('announcements');
        this.prepareAnnouncement();
    }


    $onChanges(onChangesObj: angular.IOnChangesObject): void {
        super.$onChanges(onChangesObj);
    }

    private prepareAnnouncement() {
        this.loading = false;
        let currentAnnouncement = this.appModel.currentAnnouncement;
        this.$log.debug('id: ' + currentAnnouncement.id + 'name: ' + currentAnnouncement.name);
        this.textLayer = currentAnnouncement.template.templateLayers[0].templateLayerClips;
        this.deliveryTypes = currentAnnouncement.template.templateDeliveryTypes;
        this.setDeliveryTypeSwitches();
        this.createDisplaylist();
    }

    /**
     * Creates the announcement from template id
     */
    // private createAnnouncement() {
    //     this.Rest.one('templates', this.appModel.currentTemplate.id).all('announcement').post(null)
    //         .then(
    //             (data) => {
    //                 this.appModel.currentAnnouncement = data;
    //                 this.prepareAnnouncement();
    //             },
    //             (data: IResponse) => {
    //                 //errors are handled in interceptor
    //             })
    //     ;
    // }

    /**
     * Enable and preset availabe DeliveryType switches
     */
    private setDeliveryTypeSwitches(): void {
        for (var i = 0; i < this.deliveryTypes.length; i++) {
            var tdt: ITemplateDeliveryTypes = this.deliveryTypes[i];
            tdt.selected = false;
            tdt.disabled = false;
            switch (tdt.deliveryType.id) {
                case 1:
                    if (this.appModel.account.phoneNumber) {
                        tdt.selected = true;
                        tdt.disabled = false;
                    }
                    break;
                case 2:
                    if (this.appModel.account.mobileNumber) {
                        tdt.selected = true;
                        tdt.disabled = false;
                    }
                    break;
                case 6:
                    if (this.appModel.account.mobileNumber) {
                        tdt.selected = true;
                        tdt.disabled = false;
                    }
                    break;
                case 7:
                    tdt.selected = true;
                    tdt.disabled = false;
                    break;
            }


        }
    }

    /**
     *
     */
    private async createDisplaylist() {
        console.log('createDisplaylist');
        var template = this.appModel.currentAnnouncement.template;
        this.templateText = "";
        var textLayerClips: ITemplateLayerClips[] = template.templateLayers[0].templateLayerClips;
        var accountAutomaticBlocks: IAccountAutomaticBlocks[] = this.appModel.account.accountAutomaticBlocks;
        for (const textLayerClip of textLayerClips) {
            this.templateText = this.templateText + textLayerClip.name + " ";

            //process automatic Blocks
            if (textLayerClip.type == "AutomaticBlock") {
                var staticBlock: IBlock = _.find(accountAutomaticBlocks, (item) => {
                    return item.automaticBlock.id == textLayerClip.clipId
                }).staticBlock;
                textLayerClip.name = staticBlock.name;
                textLayerClip.clipId = staticBlock.id;
                textLayerClip.type = staticBlock.type;
                textLayerClip.class = "automaticBlock";
                textLayerClip.isComplete = true;
            }
            //process manual Blocks
            else if (textLayerClip.type == "ManualBlock") {
                let announcementManualBlocks = this.appModel.currentAnnouncement.announcementManualBlocks;

                // use class attribute to determine if first load and if yes set name as title
                textLayerClip.class ? null : textLayerClip.title = textLayerClip.name;
                textLayerClip.class = "manualBlock";
                var listId: number = textLayerClip.suggestionListId;

                if(!this.suggestionLists[listId]){
                    await this.getListOptions(listId);
                }

                announcementManualBlocks?.some((block) => {
                    if (block.templateLayerClipId == textLayerClip.templateLayerClipId) {
                        textLayerClip.name = block.staticBlockName;
                        textLayerClip.isComplete = true;
                    }
                });

                if(textLayerClip.manualBlockType == "DAY"){
                    this.hasAutoDateBlock = true;
                    if(this.end){ //if we have a end date use it as default
                        let day = this.suggestionLists[listId][this.end.getDate() - 1 ]
                        await this.updateManualBlock(day, textLayerClip);
                    }
                    if(this.noScheduler){
                        textLayerClip.isComplete = true;
                    }
                    this.noEnd = false;
                }

                if(textLayerClip.manualBlockType == "MONTH"){
                    this.hasAutoDateBlock = true;
                    if(this.end){
                        let month = this.suggestionLists[listId][this.end.getMonth()]
                        await this.updateManualBlock(month, textLayerClip);
                    }
                    if(this.noScheduler){
                        textLayerClip.isComplete = true;
                    }
                    this.noEnd = false;
                }

            }
            //process Digit Blocks
            else if (textLayerClip.type == "DigitBlock") {
                let announcementDigitBlocks = this.appModel.currentAnnouncement.announcementDigitBlocks;

                announcementDigitBlocks?.some((block)=>{
                    if(block.templateLayerClipId == textLayerClip.templateLayerClipId){
                        textLayerClip.name = block.value;
                        textLayerClip.class = "digitBlock";
                    }
                });

                if (textLayerClip.name == "Mobilenumber") {
                    textLayerClip.name = this.appModel.account.mobileNumber;
                    this.markPendingBlockUpdate(textLayerClip, textLayerClip.name);
                } else if (textLayerClip.name == "Phonenumber") {
                    textLayerClip.name = this.appModel.account.phoneNumber;
                    this.markPendingBlockUpdate(textLayerClip, textLayerClip.name);
                } else {
                    // Prefill aus localStorage (zuletzt eingegebener Wert für dieses Template)
                    if (!textLayerClip.class) {
                        const savedValue = this.getBlockValue('digitblock', template.id, textLayerClip.templateLayerClipId);
                        if (savedValue) {
                            textLayerClip.name = savedValue;
                            textLayerClip.class = "digitBlock";
                            this.markPendingBlockUpdate(textLayerClip, savedValue);
                        } else {
                            textLayerClip.name = "";
                        }
                    }
                }

                textLayerClip.class = "digitBlock";

                //update Announcement Status
                textLayerClip.name == "" ? textLayerClip.isComplete = false : textLayerClip.isComplete = true;

            }
            //process Ki Blocks
            else if (textLayerClip.type == "KIBlock") {
                let announcementKIBlocks = this.appModel.currentAnnouncement.announcementKIBlocks;

                //use class attribut to determine if this is first load
                if(!textLayerClip.class){
                    textLayerClip.title = textLayerClip.name;
                    textLayerClip.name = "";
                }
                textLayerClip.class ? null : textLayerClip.name = "";

                textLayerClip.class = "kiBlock";

                announcementKIBlocks?.some((block)=>{
                    if(block.templateLayerClipId == textLayerClip.templateLayerClipId){
                        textLayerClip.name = block.value;
                        textLayerClip.class = "kiBlock";
                    }
                });

                // Prefill aus localStorage wenn kein Wert aus Ansage vorhanden
                if (textLayerClip.name == "") {
                    const savedValue = this.getBlockValue('kiblock', template.id, textLayerClip.templateLayerClipId);
                    if (savedValue) {
                        textLayerClip.name = savedValue;
                        this.markPendingBlockUpdate(textLayerClip, savedValue);
                    }
                }

                //update Announcement Status
                textLayerClip.name == "" ? textLayerClip.isComplete = false : textLayerClip.isComplete = true;
                textLayerClip.maxLength ? null : textLayerClip.maxLength = 600;
            }


        }
        this.textLayer = textLayerClips;
        this.checkIsComplete();
        //this.$s.$apply();
        this.loading = false;
        this.$timeout(() => this.flushPendingBlockUpdates(), 0);
    }

    /**
     *
     * @returns {boolean}
     */
    private checkIsComplete(): boolean {
        var textLayerClips: ITemplateLayerClips[] = this.appModel.currentAnnouncement.template.templateLayers[0].templateLayerClips;
        var isComplete: boolean = true;
        for (var i = 0; i < textLayerClips.length; i++) {
            if (textLayerClips[i].type != "StaticBlock" && textLayerClips[i].type != "Music") {
                textLayerClips[i].isComplete ? null : isComplete = false;
            }
        }
        this.$log.debug("IsComplete:" + isComplete);
        this.isComplete = isComplete;
        return isComplete;
    }

    /**
     *
     * @param listId
     */
    private async getListOptions(listId: number): Promise<void> {
        try {
            const data = await this.announcements.one('suggestionLists', listId).get();
            this.appModel.suggestionLists[listId] = data;
            this.suggestionLists = this.appModel.suggestionLists;
            console.log('fetched List Options for id: ' + listId);
        } catch (error) {
            // Handle errors locally if needed, even if globally handled
            console.error('Error fetching suggestion list:', error);
        }
    }



    private async prelisten() {
        await this.flushPendingBlockUpdates();
        this.prelistenService.togglePrelisten(this.appModel.currentAnnouncement);
    }

    private download(mediaType?: { type, extension }) {
        this.prelistenService.download(this.appModel.currentAnnouncement, mediaType, this.template.name);
    }


    private locationChangeEventHandle;

    /**
     *
     * @param clip
     */
    private openList(clip: ITemplateLayerClips) {

        if(clip.manualBlockType != "DEFAULT"){
            this.showEnd = true;
            return;
        }

        this.currentList = this.appModel.suggestionLists[clip.suggestionListId];
        this.currentClip = clip;
        // Prevent Back Button history
        // this.locationChangeEventHandle = this.$rs.$on('$locationChangeStart', (event) => {
        //     this.currentList = null;
        //     this.currentClip = null;
        //     event.preventDefault();
        //     //removes the handle after call
        //     this.locationChangeEventHandle = null;
        // })
    }


    /**
     *
     * @param clip
     */
    private updateDigitBlock(clip: ITemplateLayerClips) {
        this.clearPendingBlockUpdate(clip);
        if (clip.name.length == 0) {
            clip.isComplete = false;
            return;
        }
        //prevent render of unchaged clips
        if(clip.name==clip.previousName){
            return;
        } else {
            clip.previousName = clip.name;
        }

        // prettyprint Number
        var value = clip.name;
        if (/^[0-9+]+$/.test(value)) {
            this.phoneNumberFormatter.format(value, this.appModel.account && this.appModel.account.mobileNumber)
                .then((formatted: string) => {
                    this.$log.debug('prettyprint return: ' + formatted);
                    if (/^[0-9 \n\r]+$/.test(formatted)) {
                        clip.name = formatted.replace(/(\r\n|\n|\r)/gm, "");
                    }
                    this.performUpdateDigitBlock(clip);
                }).catch(() => {
                    this.$log.error("Error PrettyPrinting Number");
                    this.performUpdateDigitBlock(clip);
                });
        } else {
            this.performUpdateDigitBlock(clip);
        }
    }

    public updateKiBlock(clip: ITemplateLayerClips) {
        this.clearPendingBlockUpdate(clip);
        if (clip.name.length == 0) {
            clip.isComplete = false;
            return;
        }
        //prevent render of unchaged clips
        if(clip.name==clip.previousName){
            return;
        } else {
            clip.previousName = clip.name;
        }
        this.performUpdateKiBlock(clip);
    }


    private static readonly PREFILL_STORAGE_KEY = 'jingle_block_prefill';

    private saveBlockValue(type: string, templateLayerClipId: number, value: string): void {
        const templateId = this.appModel.currentAnnouncement.template.id;
        const key = `${type}_${templateId}_${templateLayerClipId}`;
        const prefill = this.loadPrefillData();
        if (value && value.length > 0) {
            prefill[key] = value;
        } else {
            delete prefill[key];
        }
        localStorage.setItem(EditAnnouncement.PREFILL_STORAGE_KEY, JSON.stringify(prefill));
    }

    private getBlockValue(type: string, templateId: number, templateLayerClipId: number): string | null {
        const key = `${type}_${templateId}_${templateLayerClipId}`;
        return this.loadPrefillData()[key] || null;
    }

    private loadPrefillData(): { [key: string]: string } {
        try {
            return JSON.parse(localStorage.getItem(EditAnnouncement.PREFILL_STORAGE_KEY)) || {};
        } catch (e) {
            return {};
        }
    }

    //we need to Chain request not to run in concurency update situations with announcement version.
    private requestChain: IQueuedBlockUpdate[] = [];
    private pendingBlockUpdates: IQueuedBlockUpdate[] = [];
    private activeBlockUpdate: IQueuedBlockUpdate = null;
    public requestPending = false;
    private requestWaiters: Array<() => void> = [];

    /**
     *
     * @param clip
     */
    private performUpdateDigitBlock(clip: ITemplateLayerClips, blockValue: string = clip.name) {
        if (this.requestPending) {
            this.queueLatestBlockUpdate(clip, blockValue);
            return;
        }
        this.requestPending = true;
        clip.isComplete = true;
        const value = blockValue;
        this.activeBlockUpdate = this.createBlockUpdate(clip, value);
        this.announcements.one(this.appModel.currentAnnouncement.id.toString())
            .one('digitBlocks', clip.templateLayerClipId)
            .post(value, {}, {
                'announcementVersion': this.appModel.currentAnnouncement.version
            })
            .then((data) => {
                this.appModel.currentAnnouncement.version = data.version;
                this.markDigitBlockPersisted(clip, value);
                this.$log.log('Digit Block gespeichert:' + clip.templateLayerClipId + "->" + value);
                this.saveBlockValue('digitblock', clip.templateLayerClipId, value);
                this.activeBlockUpdate = null;
                this.requestPending = false;
                this.nextRequest();
            }, (data: IResponse) => {
                //errors are handled in interceptor
                clip.isComplete = false;
                this.activeBlockUpdate = null;
                this.requestPending = false;
                this.nextRequest();
            })
    }


    private performUpdateKiBlock(clip: ITemplateLayerClips, blockValue: string = clip.name){
        if (this.requestPending) {
            this.queueLatestBlockUpdate(clip, blockValue);
            return;
        }
        this.requestPending = true;
        clip.isComplete = true;
        const value = blockValue;
        this.activeBlockUpdate = this.createBlockUpdate(clip, value);
        this.announcements.one(this.appModel.currentAnnouncement.id.toString())
        .one('kiBlocks', clip.templateLayerClipId)
        .post(null, value, {
            'announcementVersion': this.appModel.currentAnnouncement.version
        },{
            'Content-Type': 'text/plain'
        })
        .then((data) => {
            this.appModel.currentAnnouncement.version = data.version;
            this.markKiBlockPersisted(clip, value);
            this.$log.log('Ki Block gespeichert:' + clip.templateLayerClipId + "->" + value);
            this.saveBlockValue('kiblock', clip.templateLayerClipId, value);
            this.activeBlockUpdate = null;
            this.requestPending = false;
            this.nextRequest();
        }, (data: IResponse) => {
            console.log('Error saving Ki Block: ' + data);
            clip.isComplete = false;
            this.activeBlockUpdate = null;
            this.requestPending = false;
            this.nextRequest();
        })
    }

    private markKiBlockPersisted(clip: ITemplateLayerClips, value: string): void {
        if (!this.appModel.currentAnnouncement.announcementKIBlocks) {
            this.appModel.currentAnnouncement.announcementKIBlocks = [];
        }

        const existingBlock = this.appModel.currentAnnouncement.announcementKIBlocks.find((block) => {
            return block.templateLayerClipId == clip.templateLayerClipId;
        });

        if (existingBlock) {
            existingBlock.value = value;
        } else {
            this.appModel.currentAnnouncement.announcementKIBlocks.push({
                templateLayerClipId: clip.templateLayerClipId,
                value: value
            });
        }
    }

    private markDigitBlockPersisted(clip: ITemplateLayerClips, value: string): void {
        if (!this.appModel.currentAnnouncement.announcementDigitBlocks) {
            this.appModel.currentAnnouncement.announcementDigitBlocks = [];
        }

        const existingBlock = this.appModel.currentAnnouncement.announcementDigitBlocks.find((block) => {
            return block.templateLayerClipId == clip.templateLayerClipId;
        });

        if (existingBlock) {
            existingBlock.value = value;
        } else {
            this.appModel.currentAnnouncement.announcementDigitBlocks.push({
                templateLayerClipId: clip.templateLayerClipId,
                value: value
            });
        }
    }

    private markPendingBlockUpdate(clip: ITemplateLayerClips, value: string): void {
        if (!value || value.length === 0) {
            return;
        }

        if (this.hasMatchingBlockUpdate(this.activeBlockUpdate, clip, value)
            || this.requestChain.some((update: IQueuedBlockUpdate) => this.hasMatchingBlockUpdate(update, clip, value))) {
            return;
        }

        clip.previousName = value;
        this.pendingBlockUpdates = this.pendingBlockUpdates.filter((pendingUpdate: IQueuedBlockUpdate) => {
            return pendingUpdate.type !== clip.type || pendingUpdate.templateLayerClipId !== clip.templateLayerClipId;
        });
        this.pendingBlockUpdates.push(this.createBlockUpdate(clip, value));
    }

    private clearPendingBlockUpdate(clip: ITemplateLayerClips): void {
        this.pendingBlockUpdates = this.pendingBlockUpdates.filter((pendingUpdate: IQueuedBlockUpdate) => {
            return pendingUpdate.type !== clip.type || pendingUpdate.templateLayerClipId !== clip.templateLayerClipId;
        });
    }

    private async flushPendingBlockUpdates(): Promise<void> {
        if (this.pendingBlockUpdates.length > 0) {
            const pendingUpdates = this.pendingBlockUpdates.splice(0);
            pendingUpdates.forEach((pendingUpdate: IQueuedBlockUpdate) => {
                const value = pendingUpdate.clip.name;
                if (value && value.length > 0) {
                    this.queueLatestBlockUpdate(pendingUpdate.clip, value);
                }
            });

            if (!this.requestPending) {
                this.nextRequest();
            }
        }

        await this.waitForPendingRequests();
    }

    private queueLatestBlockUpdate(clip: ITemplateLayerClips, value: string): void {
        if (this.hasMatchingBlockUpdate(this.activeBlockUpdate, clip, value)) {
            return;
        }

        this.requestChain = this.requestChain.filter((queuedUpdate: IQueuedBlockUpdate) => {
            return queuedUpdate.type !== clip.type || queuedUpdate.templateLayerClipId !== clip.templateLayerClipId;
        });
        this.requestChain.push(this.createBlockUpdate(clip, value));
    }

    private createBlockUpdate(clip: ITemplateLayerClips, value: string): IQueuedBlockUpdate {
        return {
            clip: clip,
            type: clip.type,
            templateLayerClipId: clip.templateLayerClipId,
            value: value
        };
    }

    private hasMatchingBlockUpdate(update: IQueuedBlockUpdate, clip: ITemplateLayerClips, value: string): boolean {
        return update
            && update.type === clip.type
            && update.templateLayerClipId === clip.templateLayerClipId
            && update.value === value;
    }

    private nextRequest(){
        if (this.requestChain.length > 0) {
            let update = this.requestChain.shift();
            if(update.type == "DigitBlock") {
                this.performUpdateDigitBlock(update.clip, update.value);
            } else if (update.type == "KIBlock") {
                this.performUpdateKiBlock(update.clip, update.value);
            }
        } else {
            this.checkIsComplete();
            this.resolveRequestWaiters();
        }
    }

    private waitForPendingRequests(): Promise<void> {
        if (!this.requestPending && this.requestChain.length === 0) {
            return Promise.resolve();
        }

        return new Promise<void>((resolve) => {
            this.requestWaiters.push(resolve);
        });
    }

    private resolveRequestWaiters(): void {
        const waiters = this.requestWaiters.splice(0);
        waiters.forEach(resolve => resolve());
    }

    public async updateManualBlock(listItem, clip: ITemplateLayerClips) {
        console.log('updateManualBlock: ' + clip.templateLayerClipId + " to: " + listItem.name);
        clip.isComplete = false;
        this.$rs.showLoading = true;

        try {
            const data = await this.Rest.one('announcements', this.appModel.currentAnnouncement.id).one('manualBlocks', clip.templateLayerClipId).post(listItem.id, {}, {});

            console.log('Manual Block gespeichert:' + clip.templateLayerClipId);
            this.appModel.currentAnnouncement.version = data.version;
            clip.isComplete = true;
            this.checkIsComplete();
        } catch (error) {
            this.$log.error('Error replace manualBlock');
            this.$rs.errormessage = 'Error replacing Block';
        }

        clip.name = listItem.name;
        clip.clipId = listItem.id;

        this.currentList = null;
        this.$s.$apply();
    }


    /**
     *
     */
    public async activateAnnouncement() {
        await this.flushPendingBlockUpdates();
        if (this.appModel.demoMode) {
            this.$rs.errormessage = "ERROR_NO_ACTIVATION_IN_DEMO";
            return;
        }
        if (!this.isComplete) {
            this.$rs.errormessage = "Bitte vervollständigen Sie zunächst die Ansage";
            this.$log.warn('Announcement incomplete.');
            return;
        }
        if (!this.noEnd && this.begin && this.end < this.begin) {
            this.$rs.errormessage = 'ERROR_ENDDATE_BEFORE_BEGINDATE';
            return;
        }
        try {
            await this.deliveryService.activateAnnouncement(this.appModel.currentAnnouncement, this.isActivateNow ? null : this.begin, this.noEnd ? null : this.end, this.deliveryTypes);
            this.$rs.$back();
        } catch (error) {
            this.$log.error('Error during announcement activation:', error);
        }
    }

    public async saveAnnouncement() {
        await this.flushPendingBlockUpdates();
        if (!this.isComplete) {
            this.$rs.errormessage = "Bitte vervollständigen Sie zunächst die Ansage";
            this.$log.warn('Announcement incomplete.');
            return;
        }

        this.Rest.one('/accounts/me/').post(this.autoAnnouncementType +"/" + this.appModel.currentAnnouncement.id)
        .then((data) => {
            this.$location.path("/main").search({});
        });

    }

    public unsetAnnouncement() {
        this.Rest.one('/accounts/me/' + this.autoAnnouncementType).remove()
        .then((data) => {
            this.$location.path("/main").search({});
        });
    }


    public hasDeliveryType(id: number): boolean {
        return this.deliveryTypes.find(tdt => tdt.deliveryType.id === id) !== undefined;
    }

    public canActivate() {
        //check if deliveryTypes array contains at least one element with id!=4
        return this.isComplete && this.deliveryTypes?.filter(tdt => tdt.deliveryType.id != 4).length > 0;
    }


}

app.component('editAnnouncement', {
    bindings: {
        // type: '<',
        // noScheduler: '<',
    },
    templateUrl: 'ts/components/editAnnouncement/editAnnouncement.html',
    controller: EditAnnouncement
})
